/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from 'react';
import { THEME } from '../global/Theme';
import '../App.css';
import { Link } from 'react-router-dom';
import backLight from '../asset/image/close_light.svg'
import backDark from '../asset/image/close_dark.svg'
import { ossData } from '../asset/data/ossList'
import { DirectLink, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'


const OssContent = ({ theme, data }) => {

    const linkColor = theme.themeName === 'LIGHT' ? 'blue' : 'skyblue'
    const licenseName = ossData.license[data.license].title

    return (
        <div className="App-text" style={{ fontSize: 'calc(4px + 1vmin)' }}>
            <p style={{ display: 'flex', flexDirection: 'column', marginLeft: '1em', marginRight: '1em', textAlign: 'left' }}>
                <span style={{ fontWeight: 'bold' }}>{data.title}</span>
                <a target="_blank" rel="noopener noreferrer" style={{ color: linkColor, marginLeft: '1em' }} href={data.url}>{data.url}</a>
                {
                    data.url2 ? (
                        <a target="_blank" rel="noopener noreferrer" style={{ color: linkColor, marginLeft: '1em' }} href={data.url2}>{data.url2}</a>
                    ) : null
                }
                <span style={{ marginLeft: '1em', color: theme.textDisableColor }}>{data.author}</span>
                <span style={{ marginLeft: '1em', color: theme.textDisableColor }}>{licenseName}</span>
            </p>
        </div>
    )
}

const OssLicense = ({ theme, data }) => {

    return (
        <div className="App-text" style={{ fontSize: 'calc(4px + 1vmin)' }}>
            <p style={{ display: 'flex', flexDirection: 'column', marginLeft: '1em', marginRight: '1em', textAlign: 'left' }}>
                <span style={{ fontWeight: 'bold', marginBottom: '0.8em' }}>{data.title}</span>
                {
                    data.desc.split('\n').map(line => {
                        return (<span style={{ marginLeft: '1em', color: theme.textDisableColor }}>{line}<br /></span>)
                    })
                }
            </p>
        </div>
    )
}

class OSSNotice extends Component {

    render() {

        const { theme, closeOssNotice } = this.props

        const img = theme.themeName === 'LIGHT' ? backLight : backDark

        return (
            <div className="App" style={{ backgroundColor: theme.themeName === 'DARK' ? theme.backgroundColor : 'white' }}>

                <div style={{ paddingLeft: '1em', width: 'calc(100% - 1em)', height: '3em', display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: theme.naviBarColor, color: theme.textColor }}>
                    {/* <Link to={'/'}>
                        <img src={img} style={{ width: '1em', height: '1em', marginRight: '0.3em' }} />
                    </Link> */}
                    {ossData.tradingGame.title}
                    <div onClick={closeOssNotice} style={{ height: '3em', width: '3em', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                        <img src={img} style={{ width: '1.0em', height: '1.0em' }} />
                    </div>
                </div>
                <div style={{ width: '100%', height: 1, backgroundColor: theme.lineColor, }} />

                <Element className="element" id="containerElement" style={{
                    position: 'relative',
                    height: '80vh',
                    overflow: 'scroll',
                }}>


                    <div style={{ display: 'flex', flexDirection: 'column', width: 'calc(100% - 1em)', color: theme.textColor, justifyContent: 'flex-start' }}>
                        <p className="App-text" style={{ marginLeft: '1em', marginRight: '1em', textAlign: 'left', fontSize: 'calc(4px + 1vmin)', color: theme.textDisableColor }}>
                            {
                                ossData.tradingGame.desc.split('\n').map(line => {
                                    return (<span style={{ color: theme.textDisableColor }}>{line}<br /></span>)
                                })
                            }
                        </p>
                    </div>

                    <div style={{ width: '100%', height: 1, backgroundColor: theme.lineColor, }} />

                    <div style={{ display: 'flex', flexDirection: 'column', width: 'calc(100% - 1em)', color: theme.textColor, justifyContent: 'flex-start' }}>
                        {ossData.list.map(function (d) {
                            const data = ossData.content[d]
                            return (<OssContent key={d} theme={theme} data={data} />)
                        })}
                    </div>

                    <div style={{ width: '100%', height: 1, backgroundColor: theme.lineColor, }} />

                    <div style={{ display: 'flex', flexDirection: 'column', width: 'calc(100% - 1em)', color: theme.textColor, justifyContent: 'flex-start' }}>
                        {ossData.license_list.map(function (d) {
                            const data = ossData.license[d]
                            return (<OssLicense key={d} theme={theme} data={data} />)
                        })}
                    </div>
                </Element>


                {/* <header className="App-header" style={{ minHeight: 0, overflow: 'scroll' }}>

                    <div style={{ paddingLeft: '1em', width: 'calc(100% - 1em)', height: '3em', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', backgroundColor: theme.naviBarColor, color: theme.textColor }}>
                        <Link to={'/'}>
                            <img src={img} style={{ width: '1em', height: '1em', marginRight: '0.3em' }} />
                        </Link>
                        {ossData.tradingGame.title}
                    </div>
                    <div style={{ width: '100%', height: 1, backgroundColor: theme.lineColor, }} />

                    <div style={{ display: 'flex', flexDirection: 'column', width: 'calc(100% - 1em)', color: theme.textColor, justifyContent: 'flex-start' }}>
                        <p className="App-text" style={{ marginLeft: '1em', marginRight: '1em', textAlign: 'left', fontSize: 'calc(4px + 1vmin)', color: theme.textDisableColor }}>
                            {
                                ossData.tradingGame.desc.split('\n').map(line => {
                                    return (<span style={{ color: theme.textDisableColor }}>{line}<br /></span>)
                                })
                            }
                        </p>
                    </div>

                    <div style={{ width: '100%', height: 1, backgroundColor: theme.lineColor, }} />

                    <div style={{ display: 'flex', flexDirection: 'column', width: 'calc(100% - 1em)', color: theme.textColor, justifyContent: 'flex-start' }}>
                        {ossData.list.map(function (d) {
                            const data = ossData.content[d]
                            return (<OssContent key={d} theme={theme} data={data} />)
                        })}
                    </div>

                    <div style={{ width: '100%', height: 1, backgroundColor: theme.lineColor, }} />

                    <div style={{ display: 'flex', flexDirection: 'column', width: 'calc(100% - 1em)', color: theme.textColor, justifyContent: 'flex-start' }}>
                        {ossData.license_list.map(function (d) {
                            const data = ossData.license[d]
                            return (<OssLicense key={d} theme={theme} data={data} />)
                        })}
                    </div>



                </header> */}

            </div>
        );
    }
}


export default OSSNotice;
